import { api } from "@/lib/api";

export const loadRazorpay = () =>
  new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });

// Returns { done, booking } — handles Razorpay when keys exist, otherwise demo flow.
export const payBooking = async ({ bookingId, kind, extendTo, user, onDemo }) => {
  const orderRes = await api.post("/payments/order", {
    booking_id: bookingId,
    kind,
    ...(extendTo ? { extend_to: extendTo } : {}),
  });
  const { payment, key_id, demo } = orderRes.data;

  if (demo) {
    const proceed = onDemo ? await onDemo(payment) : true;
    if (!proceed) return { done: false };
    const verify = await api.post("/payments/verify", { payment_id: payment.payment_id });
    return { done: true, booking: verify.data.booking, demo: true };
  }

  const loaded = await loadRazorpay();
  if (!loaded) throw new Error("Could not load Razorpay checkout");

  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      key: key_id,
      amount: payment.amount * 100,
      currency: "INR",
      name: "WhatTheBark.in",
      description: kind === "extension" ? "Stay extension" : kind === "balance" ? "Balance payment" : "50% advance — slot reservation",
      order_id: payment.razorpay_order_id,
      prefill: { name: user?.name || "", email: user?.email || "", contact: user?.phone || "" },
      theme: { color: "#1E293B" },
      handler: async (resp) => {
        try {
          const verify = await api.post("/payments/verify", {
            payment_id: payment.payment_id,
            razorpay_order_id: resp.razorpay_order_id,
            razorpay_payment_id: resp.razorpay_payment_id,
            razorpay_signature: resp.razorpay_signature,
          });
          resolve({ done: true, booking: verify.data.booking });
        } catch (e) {
          reject(e);
        }
      },
      modal: { ondismiss: () => resolve({ done: false }) },
    });
    rzp.open();
  });
};
